export const baseClassesIndexName = 'classes';
export const baseMeditationsIndexName = 'meditations';
export const baseArticlesIndexName = 'articles';
